import React, {FC, useEffect, useState} from 'react';
import './App.css';
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import Login from "./pages/login";
import Home from "./pages/home";
import { TabBar } from 'antd-mobile'
import {
    AppOutline,
    UserOutline
} from 'antd-mobile-icons'
import Me from "./pages/me";
import CreateOrder from "./pages/home/createOrder";
import {getLoginUserInfo} from "./common/Utils";
import OrderDetail from "./pages/home/orderDetail";
import {useTranslation} from "react-i18next";
import Calculator from "./pages/calculator";
import Pay from "./pages/pay";
import MtnAndMoovPay from "./pages/pay/MtnAndMoovPay";
import OrangePay from "./pages/pay/OrangePay";
import EditOrder from "./pages/home/editOrder";
import HubtelCreate from "./pages/hutebl/create";
import HubtelDetails from "./pages/hutebl/details";
import HubtelVerify from "./pages/hutebl/verify";
import CheckUser from "./pages/me/checkUser";
import WavePay from "./pages/pay/wave";
import UserLogin from "./pages/customer/login";
import OrderList from "./pages/customer/orderList";
import OpayFinish from "./pages/customer/opayFinish";
import ModifyPassword from "./pages/customer/modifyPassword";
import Repayment from "./pages/customer/repayment";
import Pixel from "./pages/pay/pixel";
import PayFail from "./pages/customer/payFail";
import CongoFeexPay from "./pages/pay/congoFeexPay";
import AzampayPay from "./pages/pay/azampay";
import OpayPay from "./pages/pay/opay";
import AzamPayLogin from "./pages/azampay/login";
import AzamPayOrders from "./pages/azampay/orders";
import AzamPayPay from "./pages/azampay/pay";
import PrivacyPolicy from "./pages/app/privacyPolicy";
import UserAgreement from "./pages/app/userAgreement";
import BeninPixel from "./pages/pay/beninPixel";
import TogoFeexPay from "./pages/pay/togoFeexPay";
import WaveSn from "./pages/pay/waveSn";
import WaveCi from "./pages/pay/waveCi";
import PaySuccess from "./pages/customer/paySuccess";


const Bottom: FC = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { pathname } = location
    const { t } = useTranslation();

    const setRouteActive = (value: string) => {
        navigate('/tab' + value)
    }
    const tabs = [
        {
            key: '/home',
            title: t('tab_home'),
            icon: <AppOutline />,
        },
        // {
        //     key: '/calculator',
        //     title: t('tab_calculator'),
        //     icon: <CalculatorOutline />,
        // },
        {
            key: '/me',
            title: t('tab_me'),
            icon: <UserOutline />,
        },
    ]
    return (
        <TabBar safeArea={true} activeKey={pathname} onChange={value => setRouteActive(value)}>
            {tabs.map(item => (
                <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
            ))}
        </TabBar>
    )
}

const TabLayout: FC = () => {
    return (
        <div className={'tab-main'}>
            <div className={'tab-body'}>
                <Routes>
                    <Route path={'/'} element={<Home />} />
                    <Route path={'/home'} element={<Home />} />
                    <Route path={'/me'} element={<Me />} />
                </Routes>
            </div>
            <div className={'tab-bottom'}>
                <Bottom />
            </div>
        </div>
    );
};

function App() {
  const [isLogin, setIsLogin] = useState<boolean>(false);
  useEffect(()=> {
      let userInfo : API.CurrentUser | null = getLoginUserInfo();
      if (userInfo) {
          setIsLogin(true);
      } else {
          setIsLogin(false);
      }
  },[]);
  return (
      <div className="App">
          <Routes>
              <Route path={'/'} element={isLogin ? <TabLayout/> : <Login/>}/>
              <Route path={'/login'} element={<Login/>}/>
              <Route path="/tab/*" element={<TabLayout/>}/>
              <Route path={'/createOrder'} element={<CreateOrder/>}/>
              <Route path={'/editOrder'} element={<EditOrder/>}/>
              <Route path={'/detailOrder'} element={<OrderDetail/>}/>
              <Route path={'/cal'} element={<Calculator/>}/>
              <Route path={'/pay'} element={<Pay/>}/>
              <Route path={'/wave'} element={<WavePay/>}/>
              <Route path={'/waveS'} element={<WavePay/>}/>
              <Route path={'/wave/sn'} element={<WaveSn/>}/>
              <Route path={'/wave/ci'} element={<WaveCi/>}/>
              <Route path={'/mtnAndMoov'} element={<MtnAndMoovPay/>}/>
              <Route path={'/orange'} element={<OrangePay/>}/>
              <Route path={'/hubtel/create'} element={<HubtelCreate/>}/>
              <Route path={'/hubtel/details'} element={<HubtelDetails/>}/>
              <Route path={'/hubtel/verify'} element={<HubtelVerify/>}/>
              <Route path={'/me/checkUser'} element={<CheckUser/>}></Route>
              <Route path={'/userLogin'} element={<UserLogin/>}/>
              <Route path={'/user/orderList'} element={<OrderList/>}/>
              <Route path={'/user/result'} element={<OpayFinish/>}/>
              <Route path={'/user/pay/success'} element={<OpayFinish/>}/>
              <Route path={'/user/pay/fail'} element={<PayFail/>}/>
              <Route path={'/user/repayment'} element={<Repayment/>}/>
              <Route path={'/user/modifyPassword'} element={<ModifyPassword/>}/>
              <Route path={'/pixel'} element={<Pixel/>}/>
              <Route path={'/pixel/cm'} element={<Pixel/>}/>
              <Route path={'/pixel/bj'} element={<BeninPixel/>}/>
              <Route path={'/feex/cg'} element={<CongoFeexPay/>}/>
              <Route path={'/feex/tg'} element={<TogoFeexPay/>}/>
              <Route path={'/feex/congo'} element={<CongoFeexPay/>}/>
              <Route path={'/feex/togo'} element={<TogoFeexPay/>}/>
              <Route path={'/feex'} element={<TogoFeexPay/>}/>
              <Route path={'/pay/azampay'} element={<AzampayPay/>}/>
              <Route path={'/pay/opay'} element={<OpayPay/>}/>
              <Route path={'/azampay/login'} element={<AzamPayLogin/>}/>
              <Route path={'/azampay/orders'} element={<AzamPayOrders/>}/>
              <Route path={'/azampay/pay'} element={<AzamPayPay/>}/>
              <Route path={'/app/privacy'} element={<PrivacyPolicy/>}/>
              <Route path={'/app/userAgreement'} element={<UserAgreement/>}/>
              <Route path={'/pay/success'} element={<PaySuccess/>}/>
              <Route path={'/pay/fail'} element={<PayFail/>}/>
          </Routes>
      </div>
  );
}

export default App;
